export const segmentTimerConstraints = {
  segments: {
    array: {
      startTime: {
        presence: {
          allowEmpty: false,
          message: '^StartTime cannot be empty'
        }
      },
      endTime: {
        presence: {
          allowEmpty: false,
          message: '^EndTime cannot be empty'
        }
      }
    }
  }
};

export const segmentWorklogConstraints = {
  segments: {
    array: {
      'event.startTime': {
        presence: {
          allowEmpty: false,
          message: '^StartTime cannot be empty'
        }
      },
      'event.endTime': {
        presence: {
          allowEmpty: false,
          message: '^EndTime cannot be empty'
        }
      }
    }
  }
};
